import useTailwindConfig from './useTailwindConfig';

export default function useBreakpoints() {
    const config = useTailwindConfig();
    const breakpoints = config.theme.screens;

    const isBreakpoint = breakpoint => window.innerWidth > parseInt(breakpoints[breakpoint]);

    return {
        breakpoints,
        isBreakpoint,
    };
}